import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectWinloses = (state : GlobalState) => state.music.winloses;

export const musicWinlosesSelector = createSelector(
    [selectWinloses],
    data => data
)
